var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCrossLtr = function SvgUiCrossLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.215 18.684a2.498 2.498 0 0 0-3.483 3.58L46.468 50 18.732 77.736l-.048.05a2.498 2.498 0 0 0 3.58 3.482L50 53.533l27.736 27.735.05.048a2.498 2.498 0 0 0 3.482-3.58L53.533 50l27.735-27.736.048-.05a2.498 2.498 0 0 0-3.58-3.482L50 46.468 22.264 18.732z"
  })));
};
export default SvgUiCrossLtr;